import { useEffect, useState } from 'react';
import { APIS } from '../../config/apis';
import { REQUEST_METHOD, memoActionSet } from '@laramie/ui';
import { ServerRequest } from '../../utils/apiweb';
import { isValidString } from '../../utils/validator';
import { useDispatch, useSelector } from 'react-redux';

export const useAccess = (props) => {
    const [ready, setReady] = useState(false);
    const [accesses, setAccesses] = useState([]);
    const dispatch = useDispatch();
    const cache = useSelector((state) => state.memo.cache[props.key]);

    useEffect(() => {
        if (isValidString(props.key, true)) {
            const item = cache;
            if (item) {
                const data = [...item.value];
                setAccesses(data);
                setReady(true);
                props.onLoaded && props.onLoaded(data, true, null);
            } else {
                SearchAccesses();
            }
        }
    }, [props.key, cache]);

    // Callbacks

    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                props.onLoaded && props.onLoaded(null, false, message);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                props.onLoaded && props.onLoaded(null, false, message);
            });
    };

    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        props.onLoaded && props.onLoaded(null, false, message);
    };

    const callbackSuccess = (response) => {
        response.json()
            .then((data) => {
                dispatch(memoActionSet(props.key, data, -1)); // No timeout applied.
                setAccesses(data);
                setReady(true);
                props.onLoaded && props.onLoaded(data, true, null);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                props.onLoaded && props.onLoaded(null, false, message);
            });
    };

    // Function

    const SearchAccesses = () => {
        setReady(false);

        const paramsUrl = `/usuario`;
        
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PERMISO,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    };

    // Return

    return [accesses, ready];

};
